import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type IInfoGroupFieldConfiguration, infoGroupFieldConfigurationsManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

export const ENABLE_FIELD = 'enableInfogroupField';
export const DISABLE_FIELD = 'disableInfogroupField';
export const REORDER_FIELDS_BY_TYPE = 'reorderInfogroupFieldByType';

export const actions: ActionTree<IInfoGroupFieldConfiguration, unknown> = {
    async [ENABLE_FIELD](context, { field }: { field: string }) {
        const result = await infoGroupFieldConfigurationsManager.enable(field);
        context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: result });
    },
    async [DISABLE_FIELD](context, { field }: { field: string }) {
        const result = await infoGroupFieldConfigurationsManager.disable(field);
        context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: result });
    },
    async [REORDER_FIELDS_BY_TYPE](context, { infoGroupType, types }: { infoGroupType: string; types: string[] }): Promise<number[]> {
        const dataObjectList = await infoGroupFieldConfigurationsManager.reorderByTypes(types);
        void context.dispatch(STORE_DATA_OBJECTS, { infoGroupType, dataObjectList });
        return dataObjectList.map((value) => {
            return value.dobjId;
        });
    }
};
